import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchWorkScheduleCities } from './workScheduleApi';

export const useWorkScheduleCitiesQuery = ({ companyId }, options) =>
  useQuery(
    workScheduleQueryKeys.cities(companyId),
    () => fetchWorkScheduleCities({ companyId }),
    {
      enabled: Boolean(companyId),
      staleTime: Infinity,
      ...options,
    }
  );
